/**
 * Belstaff internal feature
 * Converts a datetime to a set of values counting down to that time
 * Time to countdown is given in the CMS banner text using a curly braces syntax e.g.
 * {{ 11/05/2022 17:00 }}
 */
function calculateCountdownTimeLeft(parsedDate: number) {
  const dateNow = Date.now();

  let delta = (parsedDate - dateNow) / 1000;

  if (delta < 0) return { finished: true };

  const days = Math.floor(delta / 86400);
  delta -= days * 86400;

  const hours = Math.floor(delta / 3600) % 24;
  delta -= hours * 3600;

  const minutes = Math.floor(delta / 60) % 60;
  delta -= minutes * 60;

  const seconds = Math.floor(delta % 60);

  const dateTime = new Date(parsedDate)
    .toLocaleString()
    .replace(/(.*)\D\d+/, "$1")
    .split(", ");

  return {
    date: dateTime[0],
    time: dateTime[1],
    days,
    hours,
    minutes,
    seconds,
  };
}

/**
 * Belstaff internal feature
 * Formats a datetime to a countdown timer and returns a formatted string of banner text
 * when given a template in [[date/time/day/hour...]] format
 * @param bannerText
 * bannerText is the html string set in the CMS
 * When the timer is finished, text in the banner inside ^^...^^ is displayed instead.
 */
export function formatCountdownBannerText(bannerText: string) {
  const countdownTimerValue = Date.parse(
    bannerText
      .match(/({{.*}})/g)?.[0]
      .replace(/({{(\s)*)/g, "")
      .replace(/((\s)*}})/g, ""),
  );

  if (countdownTimerValue) {
    const { date, time, days, hours, minutes, seconds, finished } =
      calculateCountdownTimeLeft(countdownTimerValue);

    if (finished) {
      return {
        countdown: true,
        bannerText:
          bannerText.match(/(\^\^.*\^\^)/g)?.[0].replace(/(\^\^)/g, "") || "",
        finished,
      };
    }
    return {
      countdown: true,
      bannerText: bannerText
        .replace(/({{.*}})/g, "")
        .replace(/(\[\[date\]\])/g, date)
        .replace(/(\[\[time\]\])/g, time)
        .replace(/(\[\[days\]\])/g, days.toString())
        .replace(/(\[\[hours\]\])/g, hours.toString())
        .replace(/(\[\[minutes\]\])/g, minutes.toString())
        .replace(/(\[\[seconds\]\])/g, seconds.toString())
        .replace(/(\^\^.*\^\^)/g, ""),
      finished,
    };
  }
  return { countdown: false, bannerText, finished: false };
}
